module.exports = "<form class=\"form\" [formGroup]=\"form\" (submit)=\"onSubmit()\">\n  <div class=\"fields\">\n    <app-login-email-field [form]=\"form\"></app-login-email-field>\n    <app-login-password-field [form]=\"form\"></app-login-password-field>\n    <div class=\"fields\">\n      <button type=\"submit\" class=\"button button-primary\" [disabled]=\"form.invalid\" translate>auth.login.button</button>\n    </div>\n  </div>\n</form>\n"


//////////////////
// WEBPACK FOOTER
// /var/www/borneo/prod/borneo_app/src/app/auth/login/login-form/login-form.component.html
// module id = ../../../../../src/app/auth/login/login-form/login-form.component.html
// module chunks = main